<template lang="pug">
.text-gp
  ul.text-gp__items
    li.text-gp__item(v-for="(item, index) in valueList" :key="item.id")
      v-text-field.text-gp__input(v-model="item.value"
        dense outlined 
        @update:error="resetAddError(index, $event)"
        @input="inputValue(index, $event)"
        :error="!!item.errorMsg"
        :ref="el => inputEls[index] = el"
      )
      .text-gp__btns
        v-btn(fab plain outlined small @click="addItem(index)" color="#fff").btn-add
          v-icon(color="#fff") mdi-plus
        v-btn(v-if="valueList.length !== 1"
          fab plain outlined small color="#fff"
          @click="removeItem(index)").btn-remove
          v-icon(color="#fff") mdi-minus
  .text-gp__message(v-show="message" :class="{err: mainErrors.length > 0}") {{message}}
</template>

<script>
import {v4 as uid} from 'uuid'
export default {
  emits: ['update-value'],
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inputEls: [],
      valueList: [
        { id: uid(), value: '', errorMsg: '' }
      ],
    }
  },
  computed: { 
    message(){
      const len = this.mainErrors.length
      if (len !== 0) return this.mainErrors[len - 1]
      return this.description
    },
    mainErrors (){
      const errors = [...new Set(this.valueList.filter(e => !!e.errorMsg).map(e => e.errorMsg))]
      return errors
    },
    valid () {
      return this.mainErrors.length === 0 ? true : false
    }

  },
  methods: {
    validate() {
      this.inputEls.forEach((e,i) => {
        if(e) this.inputValue(i, e.value)
      })
      return this.valid
    },
    inputValue(index, value) {
      const errMsgList = this.rules.map(rule => {
        if (rule === 'required') {
          const isAllEmpty = this.valueList.every(e => e.value == null || e.value  === '')
          if (isAllEmpty) return `${this.title}為必填欄位`
          return null
        } else if (rule === 'number') return isNaN(+value) ?  `${this.title}必須是數字` : null
        else if (rule === 'email') return /.+@.+/.test(value) ? null :`${this.title} 必須符合${rule}格式`
        else if (rule === 'id') return /^[A-Z]{1}[1-2]{1}[0-9]{8}$/.test(value) ? null : `${this.title} 必須符合${rule}格式`
        // if (rule === 'agreement') return v => !!v || '請勾選授權同意, 如有疑問請聯繫主辦單位'
        // return true
      })
      const err = errMsgList.find(e => e)
      if (err) {
        this.setError(index, err)
        return 
      }
      this.setError(index, '')
    },
    resetAddError(index, e) {
      if(!this.valueList[index].errorMsg.includes('請先填寫')) return
      const setErrorTime = 1000
      setTimeout(() => this.valueList[index].errorMsg = '', setErrorTime)
    },
    setError(index, errorMsg) {
      this.valueList[index].errorMsg = errorMsg
    },
    checkItemNotEmpty(index) {
      return (this.valueList[index].value === '' || this.valueList[index].value == null) 
        ? false : true
    },
    addItem(index) {
      const firstEmptyValueIndex = this.valueList.map(e => e.value).indexOf('')
      if (firstEmptyValueIndex !== -1) {
        this.setError(firstEmptyValueIndex, '請先填寫此處內容')
        return
      }
      const newValue = { id: uid(), value: '', errorMsg: ''}
      this.valueList.splice(index + 1, 0, newValue)
    },
    removeItem(index) {
      this.valueList = this.valueList.filter((e,i) => i !== index)
      this.inputEls = this.inputEls.filter(e => e !== null)
    },
    updateValue(value) {
      this.$emit('update-value', value)
    }
  },
  watch: {
    valueList: {
      handler (nv, ov) { 
        const result = nv.map(e => e.value)
        this.updateValue(result) 
      },
      deep: true
    }
  }
}
</script>

<style lang="sass" scoped>
ul
  list-style: none
.btn
  color: white !important
  &-add
    background-color: rgba(green,0.6) 
  &-remove
    background-color: rgba(red,0.6) 
.text-gp
  font-size: 12px
  position: relative
  color: rgba(black, 0.6)
  margin-bottom: 10px
  &__item
    display: flex
  &__btns
    flex: 0 1 
    margin-inline: 10px 0px
    gap: 0 6px 
    display: flex
  &__message
    position: absolute
    bottom: -6px
    left: 10px
.err
  color: red
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForm/InputTextGP.vue